import { RaskRoller } from "~app/common/models/constants";
import { StartInfoBox } from "./start.models";

const boxes: StartInfoBox[] = [
    {
        title: "Kundorder",
        description: "Administrera kundorder",
        state: "kundorder",
        icon: "fad fa-wallet",
        aid: "kundorderlink",
        requiredRoles: RaskRoller.role.Titta
    },
    {
        title: "Produktionsplanera",
        description: "Planera produktion",
        state: "planera",
        icon: "fad fa-tasks-alt",
        aid: "planeralink",
        requiredRoles: RaskRoller.role.Titta
    },
    {
        title: "Virkesköp",
        description: "Administrera avtal och kontrakt",
        state: "virkeskop/avtal",
        icon: "fad fa-handshake",
        aid: "virkeskoplink",
        requiredRoles: [
            RaskRoller.role.Virkeskopa,
            RaskRoller.role.Kopplanera,
            RaskRoller.role.Kopleda
        ]
    },
    {
        title: "Leveransplan",
        description: "Justera leveransplan",
        state: "justeraleveransplan",
        srefParams: { tab: "kundorder" },
        icon: "fad fa-table",
        aid: "leveransplanlink",
        requiredRoles: RaskRoller.role.Titta
    },
    {
        title: "Transportplanera",
        description: "Tilldela transportföretag och destinera arbetsorder",
        state: "transportplanera",
        icon: "fad fa-truck",
        aid: "transportlink",
        requiredRoles: RaskRoller.role.Titta
    },
    {
        title: "FPV",
        description: "Skogsvård",
        state: "skogsvardfpv/avtal",
        icon: "boxicon-hallbarhet",
        aid: "skogsvardFPVlink",
        requiredRoles: [RaskRoller.role.Skogsvardsuppdragsplanera]
    }
];

export default boxes;
